import {LocalizedString, SupportedLocale} from "~/core/i18n/locales";
import {PressCategory, PressSource} from "~/features/press/model";

export const PRESS_SOURCE_LABELS = {
  IOV: {
    en: "IOV",
    de: "IOV"
  },
  AKADEMIE: {
    en: "Akademie",
    de: "Academy"
  }
} satisfies Record<PressSource, LocalizedString>;

export const PRESS_CATEGORY_LABELS = {
  ENVIRONMENT: {
    en: "Environment",
    de: "Umwelt",
  },
  ENERGY: {
    en: "Energy",
    de: "Energie",
  },
  INTERNATIONAL_LAW: {
    en: "International Law",
    de: "Völkerrecht",
  },
  GENERELL: {
    en: "Generell",
    de: "Allgemein",
  },
  ORGANIZATION: {
    en: "Organization",
    de: "Organisation",
  },
  TESTIMONIALS: {
    en: "Testimonials",
    de: "Erfahrungsberichte",
  }
} satisfies Record<PressCategory, LocalizedString>;

